import { HttpClient } from '../../httpClient'

export interface UpdateNoteRequestBody {
  note: {
    asset_references: unknown[]
    asset_references_count: number
    comment: string
    creator_guid?: string
    id: string
  }
}

interface UpdateNoteResponseData {
  id: number
  user_id: number
  comment: string
  asset_references_count: number
  last_editor: number | null
  created_at: string
  updated_at: string
  asset_references: unknown[]
}

export interface UpdateNoteParams {
  workspaceSlug: string
  momentId: string
  noteId: string
}

export interface UpdateNoteRequestArgs {
  params: UpdateNoteParams
  requestBody: UpdateNoteRequestBody
}

export function updateNote({
  params,
  requestBody,
}: UpdateNoteRequestArgs): Promise<UpdateNoteResponseData> {
  const url = new URL(
    `/moments/${params.workspaceSlug}/${params.momentId}/note/${params.noteId}`,
    window.location.origin
  )

  return HttpClient()
    .put<UpdateNoteResponseData>(url.toString(), requestBody)
    .then((res) => res.data)
}
